<template>
  <div :class="['lds-ring', { small: small }]">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
</template>

<script>
export default {
  props: {
    small: Boolean,
  },
};
</script>

<style></style>
